import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

const tooltipSx = {
  tooltip: {
    sx: { maxWidth: 280, p: 1.5, bgcolor: "#1a1a2e", border: "1px solid rgba(255,255,255,0.15)" },
  },
};

const CapitalRoutingChip = ({ routingId }) => (
  <Tooltip
    title={
      <Box>
        <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>Capital Routing</Typography>
        <Typography variant="caption" sx={{ display: "block", color: "rgba(255,255,255,0.75)" }}>
          Internal transfer between Fiddux accounts. Not a company cash outflow/inflow — excluded from period totals.
        </Typography>
        {routingId && (
          <Typography variant="caption" sx={{ display: "block", mt: 0.75, fontFamily: "monospace", color: "rgba(255,255,255,0.6)" }}>
            Routing ID: {routingId}
          </Typography>
        )}
      </Box>
    }
    arrow
    placement="left"
    componentsProps={tooltipSx}
  >
    <Chip
      size="small"
      label="R"
      color="warning"
      sx={{ fontWeight: 700, minWidth: 28, cursor: "default", color: "#000" }}
    />
  </Tooltip>
);

export default CapitalRoutingChip;
